export default __webpack_public_path__ + "static/media/rappi.d74df063.webp";